import debounce from 'lodash.debounce';
import React, { useCallback, useEffect, useState } from 'react';
import {
    type BuyFamilyTariffProps,
    FamilyTariffEventTypes,
    MODAL_WIDTH,
} from 'reactApp/ui/IframePages/BuyFamilyTariff/BuyFamilyTariff.types';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import { sendDwh } from 'reactApp/utils/ga';
import { sendPostMessage } from 'reactApp/utils/windowHelper';
import useResizeObserver from 'use-resize-observer/polyfilled';

import styles from './BuyFamilyTariff.css';
import { BuyFamilyTariffContent } from './BuyFamilyTariffContent/BuyFamilyTariffContent';

export const BuyFamilyTariff: React.FC<BuyFamilyTariffProps> = ({ activeTabFromQuery, onBuyClick }) => {
    const [activeTab, setActiveTab] = useState<ETabsName>(activeTabFromQuery === 'm' ? ETabsName.month : ETabsName.year);
    const onResize = useCallback(
        debounce(({ height = 0 }: { height: number }) => {
            sendPostMessage({ key: 'cloud-family-checkout', type: FamilyTariffEventTypes.size, height, width: MODAL_WIDTH });
        }),
        []
    );
    const { ref } = useResizeObserver<HTMLDivElement>({ onResize });
    useEffect(() => {
        sendDwh({ eventCategory: 'tariffs-quota', action: 'modal-tariff-show' });
    }, []);

    return (
        <div ref={ref} className={styles.contentRefWrapper}>
            <BuyFamilyTariffContent activeTab={activeTab} setActiveTab={setActiveTab} onBuyClick={onBuyClick} />
        </div>
    );
};
